import {FC, SVGAttributes} from 'react';

export const UnionIcon: FC<SVGAttributes<SVGSVGElement>> = (props) => (
	<svg viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...props}>
		<g transform="translate(0 -1.5)">
			<path d="M2 2H16L13 7L16 12H2V20H0V0H2V2Z" fill="currentColor" />
		</g>
	</svg>
);
